
import React from 'react';

export default function CancellationModal({ name, onClickClose, onChangeMessage, onClickSubmit, submitDisabled }) {
    return (
        <div style={{ textAlign: 'left' }} className="modal-container auto-width active" id="cancel-workflow-payment-modal">
            <div className="modal-screen">
                <div className="modal-content-wrapper">
                    <div onClick={onClickClose} className="modal-close-icon icon icon-x" />
                    <div className="modal-header-wrapper">
                        <h2 style={{ fontSize: "32px", fontWeight: "400", color: "#009CBA"}}>
                            Request Payment Cancellation
                        </h2>
                    </div>
                    <div className="content">
                        <div className="js-delete-confirmation maskable" id="new_payment_cancellation" data-validation="structured">
                            <div className="row">
                                <strong>{name}</strong> will need to confirm payment cancellation or contact you directly with any questions.
                            </div>
                            <div className="row">
                                <div className="interaction delete-confirmation">
                                    <label className="required" style={{ textTransform: 'none', color: "#333" }}>
                                        Please let {name} know why you're cancelling
                                    </label>
                                    <textarea
                                        onChange={onChangeMessage}
                                        placeholder="Add your message here..."
                                        required="required"
                                        className="js-delete-confirmation-input"
                                        name="payment_cancellation[message]"
                                        id="payment_cancellation_message"
                                        style={{overflow: 'hidden', overflowWrap: 'break-word', resize: 'none', height: '104.5px'}}
                                    ></textarea>
                                </div>
                            </div>
                            <div className="row actions">
                                <div onClick={onClickClose} className="button transparent medium" style={{color: '#616161'}}>nevermind</div>
                                <a
                                    href="javascript:;"
                                    onClick={onClickSubmit}
                                    id="cancel_workflow_payment_submit"
                                    className={`button primary medium js-type-delete-confirmed allow-whitespace ${submitDisabled ? 'disabled' : ''}`}
                                >
                                    SUBMIT REQUEST
                                </a>
                            </div>
                        </div>
                    </div>
                </div>
            </div>
        </div>
    )
}



// WEBPACK FOOTER //
// ./app/javascript/client/components/PaymentCancellation/CancellationModal.jsx